import { TMP_ELEMENT_POSITION, TMP_ELEMENT_SIZE } from '../shared/abstract-boxes';

export function ActionBoxViewConstructor(services, callbacks, context) {

  let joint = services.joint;
  let companyId = context.companyId;
  let siteId = context.site.id;
  let scenarioId = context.scenarioId;

  return joint.shapes.html.AbstractBoxElementView.extend({

    template: [
      '<div class="html-element action-box">',
      '  <button class="add-action center-block btn btn-alcmeon-default">',
      services.$translate.instant('parameters/quick_replies/details/add_an_action'),
      '  </button>',
      '</div>'
    ].join(''),

    initialize: function () {
      this.model.set("canBeTested", false);

      joint.shapes.html.AbstractBoxElementView.prototype.initialize.apply(this, arguments);

      // this.$box is initialized by the abstract superclass
      this.$box.find('.add-action').on('click', this.addAction.bind(this));
      setTimeout(() => this.updateValidity(), 200);
    },

    updateValidity: function () {
      const actions = this.model.getEmbeddedCells().filter(c => c.get('type') !== 'html.Next');
      this.model.setBoxValid(actions && actions.length);
    },

    resizeBox: function () {
      this.updateValidity();
      if (services.JointjsOptimisationsFactory.logCallsToResize()) {
        console.warn('ActionBoxView - resizeBox()');
      }
      let box = this.model;
      let embeddedCells = box.getEmbeddedCells();

      let $addAction = this.$box.find('.add-action');

      let next = embeddedCells.find(c => c.get('type') === 'html.Next');
      let actions = embeddedCells.filter(c => c.get('type') !== 'html.Next');
      if (!next) {
        return;
      }

      //Reposition and resize every action
      let ypos = 0;
      for (let child of actions) {
        let childView = this.paper.findViewByModel(child);
        child.position(0, ypos, { parentRelative: true });
        let childHeight = childView.$box.outerHeight();
        child.resize(box.attributes.size.width, childHeight);
        ypos += childHeight;
      }

      //Reposition addAction button
      $addAction.css('bottom', next.get('size').height);
      ypos += $addAction.outerHeight();

      //Reposition next
      next.position(0, ypos, { parentRelative: true });

      //resize question
      let paddingTop = 0;
      if (actions.length === 0) {
        paddingTop = $addAction.outerHeight();
      }
      box.fitEmbeds({ padding: { top: paddingTop, right: 0, bottom: 0, left: 0 } });

      //resize paper height if necessary
      callbacks.resizePaper();
    },

    // Put next action at the end
    reorderChildren: function () {
      let actionBox = this.model;
      let children = actionBox.getEmbeddedCells();

      for (let child of children) {
        actionBox.unembed(child);
      }

      let next = null;
      for (let child of children) {
        if (child.get('type') === 'html.Next') {
          // Put it aside for later
          next = child;
        } else {
          actionBox.embed(child);
        }
      }
      if (next) {
        actionBox.embed(next);
      }
    },


    createAction: function (id, position, size, action) {

      const actionShape = new joint.shapes.html.Action({
        id: id,
        position,
        size,
        action: action
      });

      this.embedAction(actionShape);
    },

    // Adds the given action to the graph
    embedAction: function (action) {

      let actionBox = this.model;
      actionBox.embed(action);
      actionBox.graph.addCell(action);

      // caller is responsible for calling this.reorderChildren() and this.resizeBox(),
      // if and when necessary
    },

    // Adds a new action with a new id; called on a add button click
    addAction: function () {
      this.newActionPromise().then(result => {
        services.QuickRepliesFactory.createUniqueId(companyId, siteId, scenarioId)
          .then(response => {

            this.createAction(response.data.id, TMP_ELEMENT_POSITION, TMP_ELEMENT_SIZE, result.action);

            this.reorderChildren();
            this.resizeBox();
          },
            services.AlertingFactory.httpErrorHandler());
      })
    },

    // Let's offer a choice of action types
    // Transfer actions can only be used in secondary scenarios, and only once per action box
    newActionPromise: function () {

      const alreadyHasATransferAction =
        this.model.getEmbeddedCells().find(child => child.get('action') && child.get('action').type === 'transferAction') !== undefined;

      return services.$uibModal.open({
        animation: true,
        template: require('./chooseActionType.modal.html'),
        controller: 'chooseActionTypeController',
        resolve: {
          includeTransferAction: !alreadyHasATransferAction,
          tagsGroups: services.ParametersFactory.getTagGroups(companyId).then(function (response) {
            return response.data;
          }),
          optins: services.AngularOptinsService.getOptins().toPromise(),
          scenarioCustomEvents: () => context.botEvents,
          scenarioCustomEventsMap: () => context.botEventsMap,
          companyId: () => companyId,
          action: {                 // Initialize the fields of a new action
            type: "tagAction",
            name: "",
            value: "",
            url: "",
            optin: {},
            scenarioCustomEvent: {}
          },
          isCampaignScenario: () => context.isCampaignScenario,
          isEditAction: false,
        }
      }).result
    }
  });
}
